export default class NativeMaterialScrollTop {
  constructor (options = {}) {
    this.data = {
      screenHeightTrigger: 0.6,
      buttonSelector: '.material-scrolltop',
      buttonRevealClass: 'reveal',
      scrollTopButtons: [],
      scrollOpts: {
        top: 0,
        left: 0,
        behavior: 'smooth'
      }
    }
  }

  updateRevealClassOnScroll () {
    let method = 'remove'
    if (window.scrollY > window.screen.height * this.data.screenHeightTrigger) {
      method = 'add'
    }
    for (const button of this.data.scrollTopButtons) {
      button.classList[method](this.data.buttonRevealClass)
    }
  }

  scrollToTop () {
    window.scroll(this.data.scrollOpts)
  }

  init () {
    window.addEventListener('scroll', () => { this.updateRevealClassOnScroll() }, { passive: true })
    this.data.scrollTopButtons = document.querySelectorAll(this.data.buttonSelector)
    for (const button of this.data.scrollTopButtons) {
      button.addEventListener('click', () => { this.scrollToTop() }, { passive: true })
    }
  }
}
